"use client";

import { c as _c } from "react/compiler-runtime";
import { Badge } from "@/components/ui/badge";
import { MetaDot } from "@/components/ui/meta-dot";
import type { BannerSeverity, GhostBanner } from "@/lib/ghost";
import { BannerDismissWrapper } from "./BannerDismissWrapper";
import { SEVERITY_LABEL, SEVERITY_STYLES } from "./banner-styles";
const SEVERITY_BADGE_VARIANT: Record<BannerSeverity, "info" | "warning" | "destructive"> = {
  info: "info",
  warn: "warning",
  critical: "destructive"
};
export function BannerRow(t0) {
  const $ = _c(24);
  const {
    banner
  } = t0;
  const t1 = `border-b px-4 py-3 text-sm sm:py-2.5 ${SEVERITY_STYLES[banner.severity]}`;
  const t2 = SEVERITY_BADGE_VARIANT[banner.severity];
  const t3 = SEVERITY_LABEL[banner.severity];
  let t4;
  if ($[0] !== t2 || $[1] !== t3) {
    t4 = <Badge variant={t2} className="shrink-0 whitespace-nowrap">{t3}</Badge>;
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== banner.title) {
    t5 = <span className="min-w-0 font-medium leading-snug sm:shrink-0">{banner.title}</span>;
    $[3] = banner.title;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t4 || $[6] !== t5) {
    t6 = <div className="flex min-w-0 items-center gap-2 sm:contents">{t4}{t5}</div>;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== banner.message) {
    t7 = banner.message ? <><MetaDot className="hidden sm:inline-block" /><span className="min-w-0 leading-snug opacity-80">{banner.message}</span></> : null;
    $[8] = banner.message;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== banner.ctaLabel || $[11] !== banner.ctaUrl) {
    t8 = banner.ctaUrl && banner.ctaLabel ? <a href={banner.ctaUrl} className="w-fit shrink-0 text-xs font-semibold underline underline-offset-2 hover:opacity-80 sm:ml-auto" target={banner.ctaUrl.startsWith("http") ? "_blank" : undefined} rel={banner.ctaUrl.startsWith("http") ? "noopener noreferrer" : undefined}>{banner.ctaLabel}</a> : null;
    $[10] = banner.ctaLabel;
    $[11] = banner.ctaUrl;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t7 || $[14] !== t8) {
    t9 = <div className="flex min-w-0 flex-col gap-2 sm:flex-1 sm:flex-row sm:items-center">{t7}{t8}</div>;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t6 || $[17] !== t9) {
    t10 = <div className="flex min-w-0 flex-col gap-2 sm:flex-row sm:items-center sm:gap-3">{t6}{t9}</div>;
    $[16] = t6;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== banner.id || $[20] !== banner.updatedAt || $[21] !== t1 || $[22] !== t10) {
    t11 = <BannerDismissWrapper bannerId={banner.id} updatedAt={banner.updatedAt} className={t1}>{t10}</BannerDismissWrapper>;
    $[19] = banner.id;
    $[20] = banner.updatedAt;
    $[21] = t1;
    $[22] = t10;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  return t11;
}